export class ExamOneValidationError extends Error {
  readonly tag = 'ExamOneValidationError';
}
